import { TPatient } from 'src/types/patient'
import { EFormType, EPatientFormStatus, TPatientForm } from 'src/types/form'
import PatientFormCard from './patient-forms/patient-form-card.component'
import NeiCard from './nei/nei-card.component'
import Morisky8Card from './morisky/morisky-8-card.component'
import AmslerGridCard from './amsler/amsler-grid-card.component'
import { useCurrentProject } from 'src/providers/current-project.provider'
import GoodToKnowFormCard from './patient-forms/good-to-know-patient-form-card.component'

export const SPECIFIC_FORM_TYPES = [
  // This form should not be displayed on patient file
  EFormType.CONSENT,
  // These forms has a specific component to show them
  EFormType.GOOD_TO_KNOW,
  EFormType.QUALITY_OF_LIFE_NEI,
  EFormType.MORISKY8,
  EFormType.AMSLER_GRID,
]

interface Props {
  patient: TPatient
  patientForms: TPatientForm[]
  currentFollowupId: number
  currentPatientFollowupId: number
}

const PatientForms = ({ patient, patientForms, currentFollowupId, currentPatientFollowupId }: Props) => {
  const { getFollowupById } = useCurrentProject()
  const followup = getFollowupById(currentFollowupId)

  const patientMedEventsForThisFollowup =
    patient.PatientMedEvents?.filter((pme) => pme.PatientFollowupId === currentPatientFollowupId) || []

  const patientFormsForThisFollowupId = patientForms.filter(
    (pf) =>
      pf.PatientFollowupId === currentPatientFollowupId ||
      patientMedEventsForThisFollowup.some((patientMedEvent) => patientMedEvent.id === pf.PatientMedEventId),
  )

  const NEIForm = patientFormsForThisFollowupId
    .filter((pf) => pf.Form?.type === EFormType.QUALITY_OF_LIFE_NEI)
    ?.find((pf) => pf.status === EPatientFormStatus.COMPLETED)

  const Morisky8Form = patientFormsForThisFollowupId
    ?.filter((pf) => pf.Form?.type === EFormType.MORISKY8)
    ?.find((pf) => pf.status === EPatientFormStatus.COMPLETED)

  const AmslerForms = patientFormsForThisFollowupId.filter(
    (pf) => pf.Form.type === EFormType.AMSLER_GRID && pf.status === EPatientFormStatus.COMPLETED,
  )

  const genericPatientForms = patientFormsForThisFollowupId.filter(
    (pf) => !SPECIFIC_FORM_TYPES.includes(pf?.Form?.type),
  )

  return (
    <div className="c-flex c-gap-6 c-flex-col">
      {genericPatientForms.map((patientForm) => (
        <PatientFormCard key={`patient-${patient.id}-form-${patientForm.id}`} patientForm={patientForm} />
      ))}

      {NEIForm && <NeiCard NeiForm={NEIForm} />}
      {Morisky8Form && <Morisky8Card form={Morisky8Form} />}
      {AmslerForms?.length > 0 && <AmslerGridCard forms={AmslerForms} />}
      {followup && followup?.configUI?.followupUI?.patientDetails?.includeGoodToKnowAttr && (
        <GoodToKnowFormCard />
      )}
    </div>
  )
}

export default PatientForms
